import { render, staticRenderFns } from "./BaseLayersTreeItem.vue?vue&type=template&id=6cfc4c8a&scoped=true"
import script from "./BaseLayersTreeItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseLayersTreeItem.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BaseLayersTreeItem.vue?vue&type=style&index=0&id=6cfc4c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfc4c8a",
  null
  
)

export default component.exports